import { Link } from 'react-router-dom';
import { categories } from '@/mocks/zh/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="text-xs font-label text-accent-500 uppercase tracking-wider">发现精彩</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
            分类<strong className="text-accent-500">导航</strong>
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-md">
            按类型找到你最爱的韩漫，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to="/category/all"
              className="group relative overflow-hidden rounded-xl aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.cover}
                alt={cat.name}
                title={`${cat.name}韩漫 - 韩漫免费网站`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-lg font-heading font-semibold text-background-50">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-100/70 mt-1">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}